import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0f7babdf from 'nuxt_plugin_plugin_0f7babdf' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_6a662f8e from 'nuxt_plugin_sentryserver_6a662f8e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_651376b1 from 'nuxt_plugin_sentryclient_651376b1' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vuescrollto_13767af4 from 'nuxt_plugin_vuescrollto_13767af4' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_templatesplugin3203583a_4145f152 from 'nuxt_plugin_templatesplugin3203583a_4145f152' // Source: ./templates.plugin.3203583a.js (mode: 'client')
import nuxt_plugin_gtm_806de4ea from 'nuxt_plugin_gtm_806de4ea' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_image_3dd86a70 from 'nuxt_plugin_image_3dd86a70' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_36f3831d from 'nuxt_plugin_cookieuniversalnuxt_36f3831d' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_6c465bee from 'nuxt_plugin_vuesocialsharingplugin_6c465bee' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_5d766fdb from 'nuxt_plugin_pluginclient_5d766fdb' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_79a03d3a from 'nuxt_plugin_pluginserver_79a03d3a' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_workbox_65fc5951 from 'nuxt_plugin_workbox_65fc5951' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_1f93bf64 from 'nuxt_plugin_metaplugin_1f93bf64' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_httpserver_7489f6a2 from 'nuxt_plugin_httpserver_7489f6a2' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_6ebea23b from 'nuxt_plugin_http_6ebea23b' // Source: ./http.js (mode: 'all')
import nuxt_plugin_axios_52d16d75 from 'nuxt_plugin_axios_52d16d75' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_261a8000 from 'nuxt_plugin_deviceplugin_261a8000' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_moment_1607d2c3 from 'nuxt_plugin_moment_1607d2c3' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vueswipeable_6a745857 from 'nuxt_plugin_vueswipeable_6a745857' // Source: ../../../plugins/vue-swipeable (mode: 'client')
import nuxt_plugin_vuecarousel_6c010c3d from 'nuxt_plugin_vuecarousel_6c010c3d' // Source: ../../../plugins/vue-carousel (mode: 'client')
import nuxt_plugin_posthog_20249709 from 'nuxt_plugin_posthog_20249709' // Source: ../../../plugins/post-hog (mode: 'client')
import nuxt_plugin_vueslider_0ba79204 from 'nuxt_plugin_vueslider_0ba79204' // Source: ../../../plugins/vue-slider (mode: 'client')
import nuxt_plugin_vuescrollpicker_334e52d1 from 'nuxt_plugin_vuescrollpicker_334e52d1' // Source: ../../../plugins/vue-scroll-picker (mode: 'client')
import nuxt_plugin_vuephonenumberinput_745d65d5 from 'nuxt_plugin_vuephonenumberinput_745d65d5' // Source: ../../../plugins/vue-phone-number-input.js (mode: 'client')
import nuxt_plugin_fontawesome_b8db358e from 'nuxt_plugin_fontawesome_b8db358e' // Source: ../../../plugins/fontawesome.js (mode: 'client')
import nuxt_plugin_trustpilot_479712e1 from 'nuxt_plugin_trustpilot_479712e1' // Source: ../../../plugins/trustpilot.js (mode: 'client')
import nuxt_plugin_clarityclient_1c4a983c from 'nuxt_plugin_clarityclient_1c4a983c' // Source: ../../../plugins/clarity.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Office Catering London | London’s Best Workplace Catering","meta":[{"name":"referrer","content":"strict-origin-when-cross-origin"},{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"},{"hid":"robots","name":"robots","content":"index, follow"},{"name":"facebook-domain-verification","content":"tvob3zh55gcidd4xe9tshq0ebbv6wm"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@nuxt_js"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fanddine.co.uk\u002F"},{"hid":"twitter:title","name":"twitter:title","content":"&Dine"},{"hid":"twitter:description","name":"twitter:description","content":"Office catering in London, done right. Quality food made by independent makers and delivered directly to your team."},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fimage.anddine.co.uk\u002FImages\u002Fmeal-box\u002FDine_SpringOffice-49.jpg"},{"hid":"og:site_name","name":"og:site_name","content":"Office catering in London, done right. Quality food made by independent makers and delivered directly to your team."},{"hid":"og:type","name":"og:type","content":"website"},{"hid":"og:url","name":"og:url","content":"https:\u002F\u002Fanddine.co.uk\u002F"},{"hid":"og:title","name":"og:title","content":"&Dine"},{"hid":"og:description","name":"og:description","content":"Office catering in London, done right. Quality food made by independent makers and delivered directly to your team."},{"hid":"og:image","name":"og:image","content":"https:\u002F\u002Fimage.anddine.co.uk\u002FImages\u002Fmeal-box\u002FDine_SpringOffice-49.jpg"},{"hid":"og:image:secure_url","name":"og:image:secure_url","content":"https:\u002F\u002Fimage.anddine.co.uk\u002FImages\u002Fmeal-box\u002FDine_SpringOffice-49.jpg"},{"hid":"og:image:alt","name":"og:image:alt","content":"&Dine"}],"script":[{"hid":"gtm","innerHTML":"(window.dataLayer = window.dataLayer || [])","type":"text\u002Fjavascript","async":true,"defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fapis.google.com\u002Fjs\u002Fapi.js","async":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-W4FCW4N')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"favicon.ico"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-W4FCW4N&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0f7babdf === 'function') {
    await nuxt_plugin_plugin_0f7babdf(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_6a662f8e === 'function') {
    await nuxt_plugin_sentryserver_6a662f8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_651376b1 === 'function') {
    await nuxt_plugin_sentryclient_651376b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_13767af4 === 'function') {
    await nuxt_plugin_vuescrollto_13767af4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin3203583a_4145f152 === 'function') {
    await nuxt_plugin_templatesplugin3203583a_4145f152(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_806de4ea === 'function') {
    await nuxt_plugin_gtm_806de4ea(app.context, inject)
  }

  if (typeof nuxt_plugin_image_3dd86a70 === 'function') {
    await nuxt_plugin_image_3dd86a70(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_36f3831d === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_36f3831d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_6c465bee === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_6c465bee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_5d766fdb === 'function') {
    await nuxt_plugin_pluginclient_5d766fdb(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_79a03d3a === 'function') {
    await nuxt_plugin_pluginserver_79a03d3a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_65fc5951 === 'function') {
    await nuxt_plugin_workbox_65fc5951(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_1f93bf64 === 'function') {
    await nuxt_plugin_metaplugin_1f93bf64(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_7489f6a2 === 'function') {
    await nuxt_plugin_httpserver_7489f6a2(app.context, inject)
  }

  if (typeof nuxt_plugin_http_6ebea23b === 'function') {
    await nuxt_plugin_http_6ebea23b(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_52d16d75 === 'function') {
    await nuxt_plugin_axios_52d16d75(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_261a8000 === 'function') {
    await nuxt_plugin_deviceplugin_261a8000(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_1607d2c3 === 'function') {
    await nuxt_plugin_moment_1607d2c3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueswipeable_6a745857 === 'function') {
    await nuxt_plugin_vueswipeable_6a745857(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_6c010c3d === 'function') {
    await nuxt_plugin_vuecarousel_6c010c3d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthog_20249709 === 'function') {
    await nuxt_plugin_posthog_20249709(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslider_0ba79204 === 'function') {
    await nuxt_plugin_vueslider_0ba79204(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollpicker_334e52d1 === 'function') {
    await nuxt_plugin_vuescrollpicker_334e52d1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuephonenumberinput_745d65d5 === 'function') {
    await nuxt_plugin_vuephonenumberinput_745d65d5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontawesome_b8db358e === 'function') {
    await nuxt_plugin_fontawesome_b8db358e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trustpilot_479712e1 === 'function') {
    await nuxt_plugin_trustpilot_479712e1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clarityclient_1c4a983c === 'function') {
    await nuxt_plugin_clarityclient_1c4a983c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
